import React from 'react';
import { ShieldAlertIcon } from 'lucide-react';
import { motion } from 'framer-motion';
import { useLang } from '../../lib/i18n/LanguageContext';
import { dictionary } from '../../lib/i18n/dictionary';
export function Compliance() {
  const {
    lang
  } = useLang();
  const t = dictionary.compliance;
  return <section id="compliance" className="py-20 md:py-24 bg-navy-deep" data-id="element-341">
      <div className="max-w-5xl mx-auto px-5 md:px-8" data-id="element-342">
        <motion.div initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.6
      }} className="border border-gold/30 rounded-md bg-navy-800/50 p-7 md:p-10" data-id="element-343">
          <div className="flex items-start gap-4" data-id="element-344">
            <div className="w-10 h-10 flex items-center justify-center bg-gold/10 border border-gold/40 rounded-sm shrink-0" data-id="element-345">
              <ShieldAlertIcon className="w-5 h-5 text-gold" data-id="element-346" />
            </div>
            <div data-id="element-347">
              <p className="font-mono text-[11px] tracking-[0.25em] uppercase text-gold mb-3" data-id="element-348">
                {t.notice[lang]}
              </p>
              <p className="text-slate-200 text-[15px] md:text-[16px] leading-relaxed" data-id="element-349">
                {t.body[lang]}
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}